import HeaderSection from "@/components/Header/HeaderSection.vue";
import SettingsUserManagementTab from "@/components/SettingsUserManagementTab/SettingsUserManagementTab.vue";
import BolideAssistant from "@/components/BolideAssistant/BolideAssistant.vue";
import { assistant_panel_mixin } from "@/components/BolideAssistant/assistant_panel_state";
import { get_user_profile, fetch_and_store_user_profile } from "@/router";

export default {
    name: "UserManagementView",

    mixins: [assistant_panel_mixin],

    components: {
        HeaderSection,
        SettingsUserManagementTab,
        BolideAssistant
    },

    data() {
        return ({
            breadcrumb: [
                { id: "home", title: "Dashboard" },
                { id: "user-management", title: "User Management" }
            ],
            user_profile: null
        });
    },

    async mounted() {
        this.user_profile = get_user_profile() || await fetch_and_store_user_profile();
    },

    methods: {
        handleBreadcrumbClick(id) {
            if (id === "home") {
                this.$router.push("/home");
            }
        }
    }
};
